import React from 'react';
import { Link } from 'react-router-dom';
import {
  CLINIC_ADDRESS,
  CLINIC_EMAIL,
  CLINIC_NAME,
  CLINIC_PHONE,
  CLINIC_PHONE_TEL,
} from '../config/clinic.config';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <div className="footer-logo">
            <img src="/images/logo.jpeg" alt={`${CLINIC_NAME} Logo`} />
          </div>
          <div className="footer-company-info">
            <p className="footer-info-text">
              Sign up for our newsletter to receive updates on special offers, news, and events.
            </p>
            <p className="footer-info-bold">
              Address: <span className="footer-info-text">{CLINIC_ADDRESS}</span>
            </p>
            <p className="footer-info-bold">
              Phone: <span className="footer-info-text">{CLINIC_PHONE}</span>
            </p>
            <p className="footer-info-bold">
              Email:{' '}
              <a href={`mailto:${CLINIC_EMAIL}`} className="footer-info-text">
                {CLINIC_EMAIL}
              </a>
            </p>
          </div>
          <div className="footer-social">
            <a href="https://facebook.com" aria-label="Facebook">
              <img src="/images/fb.png" alt="Facebook" />
            </a>
            <a href="https://instagram.com" aria-label="Instagram">
              <img src="/images/insta.png" alt="Instagram" />
            </a>
            <a href={`tel:${CLINIC_PHONE_TEL}`} aria-label="Call">
              <img src="/images/call.png" alt="Call" />
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h4>Shop</h4>
          <ul>
            <li><Link to="/">Capsules</Link></li>
            <li><Link to="/">Tablets</Link></li>
            <li><Link to="/">Ointments</Link></li>
            <li><Link to="/">Bandages</Link></li>
            <li><Link to="/">Creams</Link></li>
            <li><Link to="/">Personal Care</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>About Us</h4>
          <ul>
            <li><Link to="/about">Our Story</Link></li>
            <li><Link to="/about">The Team</Link></li>
            <li><Link to="/about">Press</Link></li>
            <li><Link to="/about">Jobs</Link></li>
            <li><Link to="/about">Blog</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Help</h4>
          <ul>
            <li><Link to="/contact">Contact & FAQ</Link></li>
            <li><Link to="/orders">Track Your Order</Link></li>
            <li><Link to="/contact">Returns & Refunds</Link></li>
            <li><Link to="/contact">Shipping & Delivery</Link></li>
            <li><Link to="/contact">Interest Free Finance</Link></li>
            <li><Link to="/contact">Cipmoney</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {CLINIC_NAME}. All Rights Reserved.</p>
        <div className="footer-credit-cards">
          <img src="/images/visa.png" alt="Visa" />
          <img src="/images/mc.png" alt="Mastercard" />
          <img src="/images/skrill.png" alt="Skrill" />
          <img src="/images/pp.png" alt="PayPal" />
          <img src="/images/ep.png" alt="Easypaisa" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
